(function () {

    a3_pilot_reports.directive('securitySearch', securitySearch);

    /**
   * @memberof PilotReports
   * @ngdoc directive
   * @name securitySearch
   * @restrict E
   * @description
   *   Implementation of securitySearch
   *   Initialize the panel with previous flight info.
   * @example
   *   Usage:
   *   <security-search id="FlightId"></security-search>
   * @ngInject
   */
    function securitySearch(AircaftPositionsFactory, FlightFactory) {
        function link($scope) {
            var showSecurityMsg =  false;
            var securitySearchRequired = null;
            var DepartureUK =  null;
            var DepartureEU =  null;
            var DepartureCDG =  null;
            var PreviousEU = null;

            var aircaftPositions = AircaftPositionsFactory.getAircaftPositionsByFlightId($scope.id);
            var flightInfo = FlightFactory.getFlightFromStorage($scope.id);

            if(flightInfo){
                DepartureUK =  flightInfo.DepartureCountry == "UNITED KINGDOM";
                DepartureEU =  flightInfo.DepartureEU;
                DepartureCDG =  flightInfo.Departure == "CDG";

                // RULE 1: Current Departure Airport is UK
                // RULE 2: Current Departure Airport is Non EU
                // RULE 3: Current Departure Airport is CDG Airport
                if(DepartureUK || !DepartureEU || DepartureCDG){
                    securitySearchRequired = true;
                }
                else{
                    securitySearchRequired = false;
                }

            }
            
            if(aircaftPositions){
                // RULE 4: Previous Origin Airport is Non EU
                PreviousEU = aircaftPositions.PreviousEU; 
                if(!PreviousEU){
                    securitySearchRequired = true;
                }
                else{
                    securitySearchRequired = false;
                }
            }
                
            if(securitySearchRequired != null){
                showSecurityMsg = true;
            }

            $scope.showSecurityMsg = showSecurityMsg;
            $scope.securitySearchRequired = securitySearchRequired;
            $scope.aircaftPositions = aircaftPositions;
        }

        return {
            restrict: 'E',
            templateUrl: "views/directives/securitySearch.tpl.html",
            scope: {
                id: '='
            },
            terminal: true,
            link: link
        }
    }
})();